/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 9527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   L1: function() { return /* binding */ PUB_SUB_EVENTS; },
/* harmony export */   Ld: function() { return /* binding */ subscribe; },
/* harmony export */   nY: function() { return /* binding */ publish; }
/* harmony export */ });
/* unused harmony export ON_CHANGE_DEBOUNCE_TIMER */
const globalScope = typeof window !== 'undefined' ? window : globalThis;
if (!globalScope.__PUBSUB_SINGLETON__) {
  globalScope.__PUBSUB_SINGLETON__ = {
    subscribers: {}
  };
}
const pubsubID = Math.random().toString(36).substring(2, 6);
const ON_CHANGE_DEBOUNCE_TIMER = 300;
const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error'
};
function subscribe(eventName, callback) {
  if (!globalScope.__PUBSUB_SINGLETON__.subscribers[eventName]) {
    globalScope.__PUBSUB_SINGLETON__.subscribers[eventName] = [];
  }
  globalScope.__PUBSUB_SINGLETON__.subscribers[eventName].push(callback);
  return function unsubscribe() {
    const list = globalScope.__PUBSUB_SINGLETON__.subscribers[eventName] || [];
    globalScope.__PUBSUB_SINGLETON__.subscribers[eventName] = list.filter(cb => cb !== callback);
  };
}
function publish(eventName, data) {
  const callbacks = globalScope.__PUBSUB_SINGLETON__.subscribers[eventName] || [];
  callbacks.forEach((callback, index) => {
    try {
      callback(data);
    } catch (e) {
      console.error(`[publish] error in callback[${index}]`, e);
    }
  });
}
if (typeof window !== 'undefined') {
  window.__PUBSUB_SINGLETON__ = globalScope.__PUBSUB_SINGLETON__; // même instance
  window.subscribe ??= subscribe;
  window.publish ??= publish;
  window.PUB_SUB_EVENTS ??= PUB_SUB_EVENTS;
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
!function() {

// EXTERNAL MODULE: ./src/js/entrypoint/global/pubsub.js
var pubsub = __webpack_require__(9527);
;// CONCATENATED MODULE: ./src/js/utils/HTMLUpdateUtility.js
class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach(callback => callback(newContent));
    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach(element => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });
    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';
    postProcessCallbacks?.forEach(callback => callback(newNode));
    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach(oldScriptTag => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach(attribute => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}
;// CONCATENATED MODULE: ./src/js/entrypoint/global/product-info.js


if (!customElements.get('product-info')) {
  customElements.define('product-info', class ProductInfo extends HTMLElement {
    quantityInput = undefined;
    quantityForm = undefined;
    quantityInputSticky = undefined;
    quantityFormSticky = undefined;
    onVariantChangeUnsubscriber = undefined;
    cartUpdateUnsubscriber = undefined;
    abortController = undefined;
    pendingRequestUrl = null;
    preProcessHtmlCallbacks = [];
    postProcessHtmlCallbacks = [];
    constructor() {
      super();
      this.quantityInput = this.querySelector('.quantity__input-primary');
      this.quantityInputSticky = this.querySelector('.quantity__input-sticky');
    }
    connectedCallback() {
      this.initializeProductSwapUtility();
      this.onVariantChangeUnsubscriber = (0,pubsub/* subscribe */.Ld)(pubsub/* PUB_SUB_EVENTS */.L1.optionValueSelectionChange, this.handleOptionValueChange.bind(this));
      this.initQuantityHandlers();
      this.dispatchEvent(new CustomEvent('product-info:loaded', {
        bubbles: true
      }));
      this.initTotalPrice();
      if (!this._onQuantityChange) {
        this._onQuantityChange = e => {
          if (e.target.matches('input[name="quantity"]')) {
            this.updateTotalPrice(e.target.value);
          }
        };
      }
      this.addEventListener('input', this._onQuantityChange);
      this.addEventListener('change', this._onQuantityChange);
      const quantity = this.quantityInput?.value || this.quantityInputSticky?.value || 1;
      this.updateTotalPrice(quantity);
    }
    addPreProcessCallback(callback) {
      this.preProcessHtmlCallbacks.push(callback);
    }
    initQuantityHandlers() {
      if (!this.quantityInput && !this.quantityInputSticky) return;
      this.quantityForm = this.querySelector('.product-form__quantity-primary');
      this.quantityFormSticky = this.querySelector('.product-form__quantity-sticky');
      if (!this.quantityForm && !this.quantityFormSticky) return;
      this.setQuantityBoundries();
      if (!this.dataset.originalSection) {
        this.cartUpdateUnsubscriber = (0,pubsub/* subscribe */.Ld)(pubsub/* PUB_SUB_EVENTS */.L1.cartUpdate, this.fetchQuantityRules.bind(this));
      }
    }
    initTotalPrice() {
      this.saleBdis = [];
      this.regularBdis = [];
      this.compareBdis = [];
      this.unitPrices = null;
      const extractNumber = el => {
        if (!el) return 0;
        return parseFloat(el.textContent.replace(/\s/g, '').replace(',', '.').replace(/[^\d.]/g, ''));
      };
      const findActivePrice = selectors => {
        for (const selector of selectors) {
          const nodes = this.querySelectorAll(selector);
          if (!nodes.length) continue;
          const value = extractNumber(nodes[0]);
          if (value > 0) {
            return {
              nodes,
              value
            };
          }
        }
        return {
          nodes: [],
          value: 0
        };
      };
      const pricesConfig = {
        sale: ['.product-form__submit .price-item--sale price-money bdi', '.product-form__submit .price-item--sale > bdi'],
        regular: ['.product-form__submit .price__regular .price-item--regular price-money bdi', '.product-form__submit .price__regular .price-item--regular > bdi'],
        compare: ['.product-form__submit .price__compare .price-item--regular price-money bdi', '.product-form__submit .price__compare .price-item--regular > bdi']
      };
      const sale = findActivePrice(pricesConfig.sale);
      const regular = findActivePrice(pricesConfig.regular);
      const compare = findActivePrice(pricesConfig.compare);
      const finalSale = sale.value > 0 ? sale : regular;
      if (!finalSale.nodes.length) return;
      this.unitPrices = {
        sale: finalSale.value,
        regular: regular.value || null,
        compare: compare.value || null
      };
      this.saleBdis = finalSale.nodes;
      this.regularBdis = regular.nodes;
      this.compareBdis = compare.nodes;
    }
    updateTotalPrice(quantity) {
      quantity = Number(quantity);
      if (!quantity || !this.unitPrices) return;
      const format = value => value.toFixed(2);
      const updateBdiPrice = (bdi, total) => {
        const prefix = bdi.querySelector('.price__prefix');
        const formatted = format(total);
        if (prefix) {
          let textNode = [...bdi.childNodes].find(n => n.nodeType === Node.TEXT_NODE);
          if (!textNode) {
            textNode = document.createTextNode('');
            bdi.insertBefore(textNode, bdi.firstChild);
          }
          textNode.nodeValue = formatted;
          return;
        }
        const currency = bdi.textContent.match(/[€$£¥]/)?.[0] ?? '€';
        bdi.textContent = `${formatted}${currency}`;
      };
      const apply = (bdis, unit) => {
        if (!unit || !bdis.length) return;
        const total = unit * quantity;
        bdis.forEach(bdi => updateBdiPrice(bdi, total));
      };
      apply(this.saleBdis, this.unitPrices.sale);
      apply(this.regularBdis, this.unitPrices.regular);
      apply(this.compareBdis, this.unitPrices.compare);
    }
    disconnectedCallback() {
      this.onVariantChangeUnsubscriber();
      this.cartUpdateUnsubscriber?.();
      this.removeEventListener('input', this._onQuantityChange);
      this.removeEventListener('change', this._onQuantityChange);
    }
    refreshTotalPrice() {
      this.initTotalPrice();
      const quantity = this.quantityInput?.value || this.quantityInputSticky?.value || 1;
      this.updateTotalPrice(quantity);
    }
    initializeProductSwapUtility() {
      this.preProcessHtmlCallbacks.push(html => html.querySelectorAll('.scroll-trigger').forEach(element => element.classList.add('scroll-trigger--cancel')));
      this.postProcessHtmlCallbacks.push(newNode => {
        window?.Shopify?.PaymentButton?.init();
        window?.ProductModel?.loadShopifyXR();
      });
    }
    handleOptionValueChange({
      data: {
        event,
        target,
        selectedOptionValues
      }
    }) {
      if (!this.contains(event.target)) return;
      this.resetProductFormState();
      const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
      this.pendingRequestUrl = productUrl;
      const shouldSwapProduct = this.dataset.url !== productUrl || this.querySelector('li[data-gang-option]') !== null;
      const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;
      this.renderProductInfo({
        requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
        targetId: target.id,
        callback: shouldSwapProduct ? this.handleSwapProduct(productUrl, shouldFetchFullPage) : this.handleUpdateProductInfo(productUrl)
      });
    }
    resetProductFormState() {
      const productForm = this.productForm;
      productForm?.toggleSubmitButton(true);
      productForm?.handleErrorMessage();
    }
    handleSwapProduct(productUrl, updateFullPage) {
      return html => {
        this.productModal?.remove();
        const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
        const variant = this.getSelectedVariant(html.querySelector(selector));
        this.updateURL(productUrl, variant?.id);
        if (updateFullPage) {
          document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;
          HTMLUpdateUtility.viewTransition(document.querySelector('main'), html.querySelector('main'), this.preProcessHtmlCallbacks, this.postProcessHtmlCallbacks);
        } else {
          HTMLUpdateUtility.viewTransition(this, html.querySelector('product-info'), this.preProcessHtmlCallbacks, this.postProcessHtmlCallbacks);
        }
      };
    }
    renderProductInfo({
      requestUrl,
      targetId,
      callback
    }) {
      this.abortController?.abort();
      this.abortController = new AbortController();
      fetch(requestUrl, {
        signal: this.abortController.signal
      }).then(response => response.text()).then(responseText => {
        this.pendingRequestUrl = null;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        callback(html);
      }).then(() => {
        // set focus to last clicked option value
        document.querySelector(`#${targetId}`)?.focus();
      }).catch(error => {
        if (error.name === 'AbortError') {
          console.log('Fetch aborted by user');
        } else {
          console.error(error);
        }
      });
    }
    getSelectedVariant(productInfoNode) {
      const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
      return !!selectedVariant ? JSON.parse(selectedVariant) : null;
    }
    buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
      const params = [];
      !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);
      if (optionValues.length) {
        params.push(`option_values=${optionValues.join(',')}`);
      }
      return `${url}?${params.join('&')}`;
    }
    updateOptionValues(html) {
      const variantSelects = html.querySelector('variant-selects[data-primary]');
      if (variantSelects) {
        HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
      }
      const variantSelectsAlt = html.querySelector('variant-selects[data-sticky]');
      if (variantSelectsAlt) {
        HTMLUpdateUtility.viewTransition(this.variantSelectorsAlt, variantSelectsAlt, this.preProcessHtmlCallbacks);
      }
      const variantSelectsDrawer = html.querySelector('variant-drawer variant-selects[data-sticky]');
      if (variantSelectsDrawer) {
        HTMLUpdateUtility.viewTransition(this.variantSelectorsDrawer, variantSelectsDrawer, this.preProcessHtmlCallbacks);
      }
    }
    handleUpdateProductInfo(productUrl) {
      return html => {
        const variant = this.getSelectedVariant(html);
        this.pickupAvailability?.update(variant);
        this.updateOptionValues(html);
        this.updateURL(productUrl, variant?.id);
        this.updateVariantInputs(variant?.id);
        if (!variant) {
          this.setUnavailable();
          return;
        }
        this.updateMedia(html, variant?.featured_media?.id);
        const updateSourceFromDestination = (id, shouldHide = source => false) => {
          const source = html.getElementById(`${id}-${this.sectionId}`);
          const destination = this.querySelector(`#${id}-${this.dataset.section}`);
          if (source && destination) {
            destination.innerHTML = source.innerHTML;
            destination.classList.toggle('hidden', shouldHide(source));
          }
        };
        updateSourceFromDestination('price');
        updateSourceFromDestination('Price-Alt');
        updateSourceFromDestination('Sku', ({
          classList
        }) => classList.contains('hidden'));
        updateSourceFromDestination('Inventory', ({
          innerText
        }) => innerText === '');
        updateSourceFromDestination('Volume');
        updateSourceFromDestination('Price-Per-Item', ({
          classList
        }) => classList.contains('hidden'));
        updateSourceFromDestination(`ProductSubmitButtonSticky`);
        updateSourceFromDestination(`ProductSubmitButtonStickyMobile`);
        updateSourceFromDestination('Price-Alt-Sticky-Mobile');
        updateSourceFromDestination(`ProductSubmitButton`);
        this.updateQuantityRules(this.sectionId, html);
        this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
        this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');
        const minValue = parseInt(this.quantityInput?.min || this.quantityInputSticky?.min || 1);
        if (this.quantityInput) {
          this.quantityInput.value = minValue;
          this.quantityInput.dispatchEvent(new Event('change', {
            bubbles: true
          }));
        }
        if (this.quantityInputSticky) {
          this.quantityInputSticky.value = minValue;
          this.quantityInputSticky.dispatchEvent(new Event('change', {
            bubbles: true
          }));
        }
        this.updateTotalPrice(minValue);
        const btnMain = html.getElementById(`ProductSubmitButton-${this.sectionId}`);
        const btnSticky = html.getElementById(`ProductSubmitButtonSticky-${this.sectionId}`);
        const btnStickyMobile = html.getElementById(`ProductSubmitButtonStickyMobile-${this.sectionId}`);
        const shouldDisable = (btnMain?.hasAttribute('disabled') ?? false) || (btnSticky?.hasAttribute('disabled') ?? false) || (btnStickyMobile?.hasAttribute('disabled') ?? false);
        this.productForm?.toggleSubmitButton(shouldDisable, shouldDisable ? theme.variantStrings.soldOut : undefined);
        this.refreshTotalPrice();
        (0,pubsub/* publish */.nY)(pubsub/* PUB_SUB_EVENTS */.L1.variantChange, {
          data: {
            sectionId: this.sectionId,
            html,
            variant
          }
        });
      };
    }
    updateVariantInputs(variantId) {
      this.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-${this.dataset.section}--alt`).forEach(productForm => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = variantId ?? '';
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }
    updateURL(url, variantId) {
      this.querySelector('share-button')?.updateUrl(`${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`);
      if (this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
    }
    setUnavailable() {
      this.productForm?.toggleSubmitButton(true, theme.variantStrings.unavailable);
      const selectors = ['price', 'Price-Alt', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules'].map(id => `#${id}-${this.dataset.section}`).join(', ');
      document.querySelectorAll(selectors).forEach(({
        classList
      }) => classList.add('hidden'));
    }
    updateMedia(html, variantFeaturedMediaId) {
      if (!variantFeaturedMediaId) return;
      const mediaGallerySource = this.querySelector('media-gallery ul');
      const mediaGalleryDestination = html.querySelector(`media-gallery ul`);
      const refreshSourceData = () => {
        if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
        const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
        const sourceSet = new Set(mediaGallerySourceItems.map(item => item.dataset.mediaId));
        const sourceMap = new Map(mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, {
          item,
          index
        }]));
        return [mediaGallerySourceItems, sourceSet, sourceMap];
      };
      if (mediaGallerySource && mediaGalleryDestination) {
        let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
        const mediaGalleryDestinationItems = Array.from(mediaGalleryDestination.querySelectorAll('li[data-media-id]'));
        const destinationSet = new Set(mediaGalleryDestinationItems.map(({
          dataset
        }) => dataset.mediaId));
        let shouldRefresh = false;

        // add items from new data not present in DOM
        for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
          if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
            mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
            shouldRefresh = true;
          }
        }

        // remove items from DOM not present in new data
        for (let i = 0; i < mediaGallerySourceItems.length; i++) {
          if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
            mediaGallerySourceItems[i].remove();
            shouldRefresh = true;
          }
        }

        // refresh
        if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

        // if media galleries don't match, sort to match new data order
        mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
          const sourceData = sourceMap.get(destinationItem.dataset.mediaId);
          if (sourceData && sourceData.index !== destinationIndex) {
            mediaGallerySource.insertBefore(sourceData.item, mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`));

            // refresh source now that it has been modified
            [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          }
        });
      }

      // set featured media as active in the media gallery
      this.querySelector(`media-gallery`)?.setActiveMedia?.(`${this.dataset.section}-${variantFeaturedMediaId}`, true);

      // update media modal
      const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
      const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
      if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
    }
    setQuantityBoundries() {
      const input = this.quantityInput || this.quantityInputSticky;
      const data = {
        cartQuantity: input?.dataset.cartQuantity ? parseInt(input.dataset.cartQuantity) : 0,
        min: input?.dataset.min ? parseInt(input.dataset.min) : 1,
        max: input?.dataset.max ? parseInt(input.dataset.max) : null,
        step: input?.step ? parseInt(input.step) : 1
      };
      let min = data.min;
      const max = data.max === null ? data.max : data.max - data.cartQuantity;
      if (max !== null) min = Math.min(min, max);
      if (data.cartQuantity >= data.min) min = Math.min(min, data.step);
      if (this.quantityInput) this.quantityInput.min = min;
      if (this.quantityInputSticky) this.quantityInputSticky.min = min;
      if (max) {
        if (this.quantityInput) this.quantityInput.max = max;
        if (this.quantityInputSticky) this.quantityInputSticky.max = max;
      } else {
        this.quantityInput?.removeAttribute('max');
        this.quantityInputSticky?.removeAttribute('max');
      }
      if (this.quantityInput) this.quantityInput.value = min;
      if (this.quantityInputSticky) this.quantityInputSticky.value = min;
      (0,pubsub/* publish */.nY)(pubsub/* PUB_SUB_EVENTS */.L1.quantityUpdate, undefined);
    }
    fetchQuantityRules() {
      const currentVariantId = this.productForm?.variantIdInput?.value;
      if (!currentVariantId) return;

      //this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
      fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`).then(response => response.text()).then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        this.updateQuantityRules(this.dataset.section, html);
      }).catch(e => console.error(e)).finally(() => {
        //this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
      });
    }
    updateQuantityRules(sectionId, html) {
      if (!this.quantityInput && !this.quantityInputSticky) return;
      this.setQuantityBoundries();
      const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`) || html.getElementById(`Quantity-Form-${sectionId}-sticky`);
      const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
      for (let selector of selectors) {
        const current = this.quantityForm?.querySelector(selector);
        const currentSticky = this.quantityFormSticky?.querySelector(selector);
        const updated = quantityFormUpdated.querySelector(selector);
        if (!updated) continue;
        if (!current && !currentSticky) continue;
        if (selector === '.quantity__input') {
          const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
          for (let attribute of attributes) {
            const valueUpdated = updated.getAttribute(attribute);
            if (valueUpdated !== null) {
              current?.setAttribute(attribute, valueUpdated);
              currentSticky?.setAttribute(attribute, valueUpdated);
            } else {
              current?.removeAttribute(attribute);
              currentSticky?.removeAttribute(attribute);
            }
          }
        } else {
          if (current) current.innerHTML = updated.innerHTML;
          if (currentSticky) currentSticky.innerHTML = updated.innerHTML;
        }
      }
    }
    get productForm() {
      return this.querySelector(`product-form`);
    }
    get productModal() {
      return document.querySelector(`#ProductModal-${this.dataset.section}`);
    }
    get pickupAvailability() {
      return this.querySelector(`pickup-availability`);
    }
    get variantSelectors() {
      return this.querySelector('variant-selects[data-primary]');
    }
    get variantSelectorsAlt() {
      return this.querySelector('variant-selects[data-sticky]');
    }
    get variantSelectorsDrawer() {
      return this.querySelector('variant-drawer variant-selects[data-sticky]');
    }
    get relatedProducts() {
      const relatedProductsSectionId = SectionId.getIdForSection(SectionId.parseId(this.sectionId), 'related-products');
      return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
    }
    get quickOrderList() {
      const quickOrderListSectionId = SectionId.getIdForSection(SectionId.parseId(this.sectionId), 'quick_order_list');
      return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
    }
    get sectionId() {
      return this.dataset.originalSection || this.dataset.section;
    }
  });
}
}();
/******/ })()
;